import { ProjectActions, TeamActions } from "@domain/schemas/workspace";
import type { ProjectAction, ProjectRoleName, TeamAction, TeamRoleName } from "@domain/schemas/workspace";
import { getProjectRoleActions, getTeamRoleActions } from "@domain/valueObjects/RoleActionMatrix";

const TEAM_ACTION_LABELS: Record<TeamAction, string> = {
  [TeamActions.ViewInventory]: "View the team's projects",
  [TeamActions.CreateProject]: "Create projects",
  [TeamActions.DeleteProject]: "Delete projects",
  [TeamActions.AssignProjectRoles]: "Assign project roles",
  [TeamActions.RenameProject]: "Rename projects",
  [TeamActions.RenameTeam]: "Rename the team",
  [TeamActions.ManageMembership]: "Manage team membership",
  [TeamActions.AssignTeamRoles]: "Assign team roles",
  [TeamActions.ManageStorageConfiguration]: "Manage storage configuration",
  [TeamActions.ManageSoftwareVersions]: "Manage software version configuration",
};

const PROJECT_ACTION_LABELS: Record<ProjectAction, string> = {
  [ProjectActions.View]: "View the project",
  [ProjectActions.TriggerJob]: "Trigger jobs",
  [ProjectActions.DeleteJobArtifacts]: "Delete job artifacts",
  [ProjectActions.ManageMembership]: "Manage project membership",
  [ProjectActions.Rename]: "Rename the project",
  [ProjectActions.ManageStorageConfiguration]: "Manage storage configuration",
  [ProjectActions.ManageSoftwareVersions]: "Manage software version configuration",
};

/**
Human-readable, bullet-separated summary of everything a team role grants - driven by the same
`RoleActionMatrix` the frontend already uses for permission checks, so it can never drift from
what the role actually does.
*/
export const describeTeamRolePermissions = (role: TeamRoleName): string =>
  getTeamRoleActions(role)
    .map((action) => TEAM_ACTION_LABELS[action])
    .join(" • ");

/**
Project-scope counterpart of {@link describeTeamRolePermissions}.
*/
export const describeProjectRolePermissions = (role: ProjectRoleName): string =>
  getProjectRoleActions(role)
    .map((action) => PROJECT_ACTION_LABELS[action])
    .join(" • ");
